import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MultiYearScalarType } from '../../types';
import './styles.css';
import ProductionProgramLayout from '../ProductionProgramLayout';
import ThreeYearsTableLayout from '../ThreeYearsTableLayout';
import OutputNumberUnit from '../OutputNumberUnit';
import BusinessPlanSubSectionTitle from '../BusinessPlanSubSectionTitle';
import range from 'lodash/range';
import LabelDescription from '../LabelDescription';
class ProductionProgram extends Component {
	render() {
		const { game } = this.props;

		const {
			soldUnits,
			internallyProducedUnits,
			outsourcedUnits,
			producedUnits,
			endingWhJuice
		} = game.production;

		const variables = [
			{ id: 'perpective-unit-sales', unit: 'U', value: soldUnits },
			{
				id: 'units-to-be-produced-internally',
				unit: 'U',
				value: internallyProducedUnits
			},
			{
				id: 'units-to-be-produced-externally',
				unit: 'U',
				value: outsourcedUnits
			},
			{ id: 'units-to-be-produced', unit: 'U', value: producedUnits },
			{
				id: 'ending-inventory',
				unit: 'U',
				description: 'ending-inventory-desc',
				value: endingWhJuice
			}
		];
		const { Header, Row, Col, Label } = ThreeYearsTableLayout;
		return (
			<div className="production-program">
				<ProductionProgramLayout>
					<BusinessPlanSubSectionTitle label={'production-program-title'} />
					<ThreeYearsTableLayout>
						<Header />
						{variables.map(variable => (
							<Row key={variable.id}>
								<Label>
									<LabelDescription
										label={variable.id}
										description={variable.description}
									/>
								</Label>
								{range(1, 4).map(n => (
									<Col key={n}>
										<OutputNumberUnit
											unit={variable.unit}
											variable={variable.value[n - 1]}
										/>
									</Col>
								))}
							</Row>
						))}
					</ThreeYearsTableLayout>
				</ProductionProgramLayout>
			</div>
		);
	}
}

ProductionProgram.propTypes = {
	game: PropTypes.shape({
		id: PropTypes.string.isRequired,
		production: PropTypes.shape({
			soldUnits: MultiYearScalarType,
			internallyProducedUnits: MultiYearScalarType,
			outsourcedUnits: MultiYearScalarType,
			producedUnits: MultiYearScalarType,
			endingWhJuice: MultiYearScalarType
		})
	})
};

export default ProductionProgram;
